/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">チェック実施設定画面</p>
                </div>
            </div>
        </div>
        <CheckImplementationSettingList/>
    </div>
</template>

<script>
    import CheckImplementationSettingList from '@/app/components/CheckImplementationSettingList.vue'
    export default {
        name: 'manageCheckImplementationMenuList',
        components: {
            CheckImplementationSettingList
        }
    }
</script>
